import React, { useContext } from "react";
import { Field, reduxForm } from "redux-form";
import { Row, Col, Alert } from 'reactstrap';


import FormValidators from "ui/FormValidators";

import { ThemeContext } from "corp-site/employer/context/ThemeContext";

import { UpwardLoadingButton, UpwardReduxInput } from "ui";


const SigninForm = (props) => {
    const context = useContext(ThemeContext);
    const { handleSubmit, isLoading, loginError } = props;
    return (
        <form onSubmit={handleSubmit}>
            <Row>
                <Col xs={{ "size": 10, "offset": 1 }} >
                    {
                        loginError && (
                            <Alert color="danger" className="my-3">
                                <div className="alert-message">
                                    {loginError}
                                </div>
                            </Alert>
                        )
                    }
                    <div className="form-group">
                        <Field
                            type="text"
                            bsSize="lg"
                            placeholder="Email"
                            name="username"
                            component={UpwardReduxInput}
                            validate={[FormValidators.required, FormValidators.email]} />
                    </div>
                    <div className="form-group">
                        <Field
                            type="password"
                            bsSize="lg"
                            placeholder="Password"
                            name="password"
                            component={UpwardReduxInput}
                            validate={[FormValidators.required]} />
                    </div>
                </Col>
            </Row>
            <Row>
                <Col xs={{ "size": 6, "offset": 3 }} className="mt-4">
                    <UpwardLoadingButton block type="submit" color="primary" size="lg" isLoading={isLoading}
                        className={"btn-rounded " + (context === "green" ? "btn-light-"+context : "btn-dark-"+context)}><b>Submit</b></UpwardLoadingButton>
                </Col>
            </Row>
        </form>
    )
}

export default reduxForm({
    form: "signinForm"
})(SigninForm);